// @flow

import React from 'react';
import { withRouter } from 'react-router';
import styles from './styles.scss';
import classnames from 'classnames';
import { preloader } from '../../utils/animation';

import type { CategoryType } from '../../api/types';

type Props = {
  history: Object,
  categories: Array<CategoryType>,
  activeCategoryName: string,
};

const convertSpacedToDashed = (string: string): string => string.replace(/\s+/g, '-');

const CategoryNav = (props: Props) => {
  const handleClick = (e: SyntheticMouseEvent<HTMLElement>) => {
    preloader().play();

    const formattedName = convertSpacedToDashed(e.currentTarget.dataset.name).toLowerCase();

    props.history.push(`/rentals/${formattedName}`);
  };

  const hasActiveClass = (categoryName: string): boolean =>
    convertSpacedToDashed(categoryName)
      .toLowerCase()
      .includes(props.activeCategoryName);

  return (
    <ul className={styles.catNav}>
      {props.categories &&
        props.categories.map(category => (
          <li key={category.id} className={classnames({ active: hasActiveClass(category.name) })}>
            <span onClick={handleClick} data-name={category.name}>
              {category.name}
            </span>
          </li>
        ))}
    </ul>
  );
};

export default withRouter(CategoryNav);



// WEBPACK FOOTER //
// ./src/components/Category/Nav.js